<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <list
      row-key="EmpId"
      ref="list"
      unit="用户"
      :expand-all-row="true"
      :page="page"
      :show-checkbox="true"
      :show-query="true"
      :get-data-func="api.list"
      urlHash="personnel/result/salary"
      :showTrendTable="showTrendTable"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="table">
        <slot name="column"></slot>
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from '@/mixins/trend/list'
import list from '@/components/common/trendsTable/list'

export default {
  mixins: [listMixin],
  components: { list },
  props: {
    showTrendTable: {
      type: Boolean,
      default: true
    },
    modelType: {
      type: String,
      default: ''
    }
  },
  provide() {
    return {
      IsDefaultMonth: false
    }
  },
  data() {
    return {
      api: require('@/api/ent/salary').default,
      params: {
        EmpName: '',
        IDNumber: '',
        Age: '',
        Sex: 1,
        MaritalStatus: 1,
        Birthday: '',
        NativePlace: '',
        Address: '',
        Phone: null,
        Email: '',
        EntryDate: '',
        EntryWork: '',
        EntryLv: null,
        EntryStatus: 1,
        EntryDp: '',
        EntryEmpType: '',
        School: '',
        Education: '',
        Major: '',
        Contact: '',
        EmergencyPhone: '',
        ContactRelationship: ''
      }
    }
  },
  methods: {
    //
    // getDetail(data) {
    //   this.$refs.detailDialog.openDetails(data)
    // },
    delRange(ids) {
      this.api.delete({ ids }).then(res => {
        if (res.Code == 0) {
          this.$message.success('删除成功')
          this.reload()
        } else {
          this.$message.error(res.Msg)
        }
      })
    }
  }
}
</script>